import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityFileTypeEnum, OfferInterface } from '@sport-activities/sdk';

import { BadgeVariantEnum } from '~/component/badge/enums/variant.enum';
import { Activity } from '~/core/model/activity.model';
import { DisplayPricePipe } from '~/core/pipes/display-price.pipe';
import { LocaleService } from '~/i18n/services/locale.service';
import { ActivityMediaResolutionEnum } from '~/organizer/shared/enums/media-resolution.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-activity-draft-card',
  templateUrl: './activity-draft-card.component.html',
  styleUrls: ['./activity-draft-card.component.scss'],
})
export class ActivityDraftCardComponent implements OnInit {
  @Input() public draftActivity: Activity;

  public readonly badgeVariantSecondary = BadgeVariantEnum.GREY_LIGHT;
  public readonly iconTypeEnum = VtmnPlayIconTypeEnum;
  public readonly priceBadgeVariant = BadgeVariantEnum.YELLOW;

  public address: string;
  public dateLocale: Locale;
  public draftPrice: string;
  public duration: string;
  public hasOffers: boolean;
  public indicativeOffers: OfferInterface[];
  public isLive = false;
  public picture: string;
  public title: string;

  constructor(
    public readonly translateService: TranslateService,
    private readonly localeService: LocaleService,
    private readonly currencyPipe: CurrencyPipe
  ) {}

  public ngOnInit(): void {
    this.setDateLocale();
    this.setMissingDetails();
    this.setDisplayPriceWithCurrency();
  }

  public setDateLocale(): void {
    this.dateLocale = this.localeService.dateLocale;
  }

  public setDisplayPriceWithCurrency(): void {
    if (this.draftActivity.startingPrice) {
      const displayPricePipe = new DisplayPricePipe(
        this.currencyPipe,
        this.translateService
      );
      this.draftPrice = displayPricePipe.transform(
        this.draftActivity.startingPrice?.amount,
        this.draftActivity.startingPrice?.currency
      );
      return;
    }
    this.draftPrice = this.translateService.instant(
      'organizer.activity.draft.missing_price'
    );
  }

  public setHasOffers(): void {
    this.hasOffers = Boolean(this.indicativeOffers?.length > 0);
  }

  public setMissingDetails(): void {
    this.title = this.draftActivity.name;
    this.duration = this.draftActivity.duration
      ? this.draftActivity.formattedDuration(this.dateLocale)
      : this.translateService.instant('organizer.activity.draft.duration');
    this.isLive = this.draftActivity.isLive;
    this.picture =
      this.draftActivity.getMediaUrlByType(
        'MAIN_MEDIA' as ActivityFileTypeEnum,
        ActivityMediaResolutionEnum.ICON
      ) || this.draftActivity.image?.url;
    this.address = this.draftActivity.fullAddress;

    this.indicativeOffers = this.draftActivity.indicativeOffers;
    if (this.title === null) {
      this.title = this.translateService.instant(
        'organizer.activity.draft.missing_title'
      );
    }
    if (!this.draftActivity.fullAddress && !this.isLive) {
      this.address = this.translateService.instant(
        'organizer.activity.draft.missing_address'
      );
    }
  }
}
